import MyTable from '../../../../components/MyTable';
import FilterPopup from '../../../../components/FilterPopup';
import { formatPhone } from '../../../../utlis';

const VendorTable = ({
  data,
  isLoading,
  onEditVendor,
  onEditContact,
  pageSize,
  onPageSizeChange,
  isFilterPopupOpen,
  onFilterClick,
  onCloseFilterPopup,
  onApplyFilters,
  getSearchResults,
  filterCategories,
  tableData,
}) => {
  // Get primary contact from contacts array
  const getPrimaryContact = (contacts) => {
    if (contacts && contacts.length > 0) {
      const primaryContact = contacts.find((c) => c.isPrimary) || contacts[0];
      const name =
        `${primaryContact.firstName || ''} ${primaryContact.lastName || ''}`.trim() ||
        'No Contact';
      const contactId = primaryContact.contact_id || primaryContact.contactId;
      return { name, contactId };
    }
    return { name: 'No Contact', contactId: null };
  };

  const columns = [
    {
      name: 'vendor_id',
      label: 'ID',
      options: {
        display: false,
      },
    },
    {
      name: 'name',
      label: 'Vendor Name',
      options: {
        customBodyRender: (value, tableMeta) => {
          const vendorId = tableMeta.rowData[0];
          const vendor = data.find((v) => v.vendor_id === vendorId);
          return (
            <h3
              onClick={() => onEditVendor(vendor)}
              className="text-base font-bold text-auxiliary-800 cursor-pointer hover:underline"
            >
              {value || '-'}
            </h3>
          );
        },
      },
    },
    {
      name: 'type',
      label: 'Vendor Type',
    },
    {
      name: 'phone',
      label: 'Phone Number',
      options: {
        customBodyRender: (value) => formatPhone(value),
      },
    },
    {
      name: 'email',
      label: 'Email',
    },
    {
      name: 'contacts',
      label: 'Contact',
      options: {
        customBodyRender: (value) => {
          const { name, contactId } = getPrimaryContact(value);
          return contactId ? (
            <h3
              onClick={() => onEditContact(contactId)}
              className="text-base font-bold text-auxiliary-800 cursor-pointer hover:underline"
            >
              {name}
            </h3>
          ) : (
            <span className="text-gray-600">{name}</span>
          );
        },
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        customBodyRender: (value) => {
          if (!value) return '';
          const statusLower = (value || '').toLowerCase();
          const getStatusStyle = () => {
            if (statusLower === 'active') return 'text-secondary-500';
            else if (statusLower === 'inactive') return 'text-danger-500';
            else return 'text-gray-500';
          };
          return (
            <p className={`py-2 rounded-full w-32 text-left ${getStatusStyle()}`}>
              {value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()}
            </p>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    rowsPerPage: pageSize,
    rowsPerPageOptions: [5, 10, 15, 20, 50],
    onChangeRowsPerPage: (numberOfRows) => onPageSizeChange(numberOfRows),
    selectableRows: 'none',
    elevation: 0,
    filter: true,
    search: false,
    download: false,
    print: false,
    viewColumns: true,
    textLabels: {
      body: {
        noMatch: !isLoading && (!data || data.length === 0) ? 'Sorry, no matching found' : '',
      },
    },
  };

  return (
    <div className="w-full overflow-x">
      <MyTable
        title=""
        data={isLoading ? [] : data}
        columns={columns}
        options={options}
        onFilterClick={onFilterClick}
      />
      {isFilterPopupOpen && (
        <FilterPopup
          onClose={onCloseFilterPopup}
          onApply={onApplyFilters}
          tableData={tableData}
          categories={filterCategories}
          getSearchResults={getSearchResults}
        />
      )}
    </div>
  );
};

export default VendorTable;
